module.exports = __webpack_public_path__ + "static/media/SerieMH.77e1e368.png";